import { t } from "@lingui/core/macro";
import { perGuestLabel } from "components/Prices/utils";
import { isPresent } from "src/utils/checks";
import { formatI18nCurrency } from "src/utils/localization/formatCurrency";

export const formatShorexPrice = (price: number | undefined) => {
  if (!isPresent(price) || price == 0) return undefined;
  const formattedPrice = formatI18nCurrency(price, "USD");
  return `${formattedPrice} ${t(perGuestLabel())}`;
};
